import { useMemo } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import apiInstance from "../../helpers/apiInstance";
import { useApp } from "../../contexts/AppContext";

function useSubscribers() {
  const { organizationId, pageId } = useApp();

  const basePath = useMemo(() => {
    return `${organizationId}/page/${pageId}/subscriber`;
  }, [organizationId, pageId]);

  // const apiInstance = useMemo(
  //   () =>
  //     axios.create({
  //       baseURL: process.env.REACT_APP_API_URL,
  //     }),
  //   []
  // );

  function uploadSubscriber(formData) {
    return apiInstance.post(`${basePath}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  const { page_Id, subscriberId } = useParams();
  return {
    createSubscriber: (payload) =>
      apiInstance.post(`/page-request/${pageId}`, payload),
    getSubscribers: (payload) =>
      apiInstance.post(basePath + "/get-subscribers/", payload),
    addSubscriber: (payload) =>
      apiInstance.post(basePath + "/create-subscriber", payload),
    updateSubscriber: (payload) =>
      apiInstance.post(basePath + "/update", payload),
    deleteSubscriber: (subscriberId) =>
      apiInstance.post(basePath + "/delete/" + subscriberId),
    saveSettings: (payload) =>
      apiInstance.post(basePath + "/save-settings/", payload),
    getSettings: () => apiInstance.post(basePath + "/settings/"),
    uploadSubscriber: uploadSubscriber,
    verifySubscriber: (variables) => {
      const { payload, token } = variables;
      return apiInstance.post(
        "/page/" + pageId + "/subscriber/" + token,
        payload
      );
    },
  };
}

export default useSubscribers;
